const queue: { prio: number; call(): void | Promise<void> }[] = [];

export function enqueue(prio: number, call: () => void | Promise<void>) {
    queue.push({ prio, call });
    queueHandler();
}

let queueHandlerActive = false;

async function queueHandler() {
    if (queueHandlerActive == true) {
        return;
    }
    queueHandlerActive = true;
    try {
        if (queue.length == 0) return;
        queue.sort((a, b) => a.prio - b.prio);
        const item = queue.shift();
        if (item == null) {
            return;
        }
        const result = item.call();
        if (result instanceof Promise) {
            await result;
        }
    } finally {
        queueHandlerActive = false;
        if (queue.length > 0) {
            requestAnimationFrame(() => {
                setTimeout(() => queueHandler(), 50);
            });
        }
    }
}
